import React, { useMemo } from 'react'
import { SwitchProps } from './types'

/**
 * Componente Switch/Toggle
 * Interruptor para valores booleanos
 */
const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  label,
  size = 'md',
  className = '',
}) => {
  // Tamaños del switch
  const sizeClasses = useMemo(() => {
    switch (size) {
      case 'sm':
        return 'h-5 w-9'
      case 'lg':
        return 'h-7 w-13'
      default:
        return 'h-6 w-11'
    }
  }, [size])

  const thumbSizeClasses = useMemo(() => {
    switch (size) {
      case 'sm':
        return 'h-4 w-4'
      case 'lg':
        return 'h-6 w-6'
      default:
        return 'h-4 w-4'
    }
  }, [size])

  const thumbTranslateClasses = useMemo(() => {
    switch (size) {
      case 'sm':
        return checked ? 'translate-x-4' : 'translate-x-0.5'
      case 'lg':
        return checked ? 'translate-x-6' : 'translate-x-0.5'
      default:
        return checked ? 'translate-x-6' : 'translate-x-1'
    }
  }, [checked, size])

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => !disabled && onChange(!checked)}
        disabled={disabled}
        className={`relative inline-flex items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
          checked ? 'bg-custom-blue' : 'bg-gray-200'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${sizeClasses}`}
      >
        <span
          className={`inline-block rounded-full bg-white transform transition-transform ${thumbSizeClasses} ${thumbTranslateClasses}`}
        />
      </button>
      {label && (
        <label
          className={`text-sm font-medium ${
            disabled ? 'text-gray-400' : 'text-gray-700 cursor-pointer'
          }`}
          onClick={() => !disabled && onChange(!checked)}
        >
          {label}
        </label>
      )}
    </div>
  )
}

export default React.memo(Switch)
